/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAlertConditionGroupFromJSON, ApiAlertConditionGroupToJSON, } from './ApiAlertConditionGroup';
import { ApiAlertRequirementPeriodFromJSON, ApiAlertRequirementPeriodToJSON, } from './ApiAlertRequirementPeriod';
import { ApiChartPayloadFromJSON, ApiChartPayloadToJSON, } from './ApiChartPayload';
export function ApiAlertRequirementPayloadFromJSON(json) {
    return ApiAlertRequirementPayloadFromJSONTyped(json, false);
}
export function ApiAlertRequirementPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'chart': !exists(json, 'chart') ? undefined : ApiChartPayloadFromJSON(json['chart']),
        'chartLastNDays': !exists(json, 'chartLastNDays') ? undefined : json['chartLastNDays'],
        'conditionGroups': !exists(json, 'conditionGroups') ? undefined : (json['conditionGroups'].map(ApiAlertConditionGroupFromJSON)),
        'period': !exists(json, 'period') ? undefined : ApiAlertRequirementPeriodFromJSON(json['period']),
    };
}
export function ApiAlertRequirementPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'chart': ApiChartPayloadToJSON(value.chart),
        'chartLastNDays': value.chartLastNDays,
        'conditionGroups': value.conditionGroups === undefined ? undefined : (value.conditionGroups.map(ApiAlertConditionGroupToJSON)),
        'period': ApiAlertRequirementPeriodToJSON(value.period),
    };
}
